import React from 'react';
import PropTypes from 'prop-types';
import { componentElDefaults, componentElPropTypes } from '../customPropTypes/componentEl';
import { classNamePropTypes, addClassNames } from '../customPropTypes/classNames';
import { addSpacingClasses, verticalPaddingPropTypes, verticalMarginPropTypes } from '../customPropTypes/spacing';
import Col from './Col';
import Row from './Row';

/*
outermost wrapper for grid
*/
import { jsx as _jsx } from "react/jsx-runtime";
function Grid(_ref) {
  var Component = _ref.componentEl,
    fluid = _ref.fluid,
    className = _ref.className,
    children = _ref.children,
    margin = _ref.margin,
    padding = _ref.padding;
  var cssClasses = [];
  cssClasses = addClassNames(className, cssClasses);
  cssClasses = addSpacingClasses({
    padding: padding,
    margin: margin,
    cssClasses: cssClasses,
    denylistMargin: ['all', 'horizontal', 'left', 'right'],
    denylistPadding: ['all', 'horizontal', 'left', 'right']
  });
  if (fluid) cssClasses.push('st_container-fluid');
  if (!fluid) cssClasses.push('st_container');
  return /*#__PURE__*/_jsx(Component, {
    className: cssClasses.join(' '),
    children: children
  });
}
process.env.NODE_ENV !== "production" ? Grid.propTypes = {
  /** dom element or component to use for outermost wrapper */
  componentEl: componentElPropTypes,
  /** extra CSS classes, if any */
  className: classNamePropTypes,
  /** whether Grid takes up all available horizontal space, or has fixed width at breakpoints */
  fluid: PropTypes.bool,
  /** optional margin, VERTICAL only */
  margin: verticalMarginPropTypes,
  /** optional padding, VERTICAL only */
  padding: verticalPaddingPropTypes
} : void 0;
Grid.defaultProps = {
  componentEl: componentElDefaults,
  className: null,
  fluid: true,
  margin: null,
  padding: null
};
Grid.Row = Row;
Grid.Row.displayName = 'Grid.Row';
Grid.Col = Col;
Grid.Col.displayName = 'Grid.Col';
export default Grid;